import { render, staticRenderFns } from "./ViewB2bimgFull.vue?vue&type=template&id=4fe04f8a&scoped=true"
import script from "./ViewB2bimgFull.vue?vue&type=script&lang=js"
export * from "./ViewB2bimgFull.vue?vue&type=script&lang=js"
import style0 from "./ViewB2bimgFull.vue?vue&type=style&index=0&id=4fe04f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe04f8a",
  null
  
)

export default component.exports